<template>
    <div v-if="show" class="modal-overlay" @click.self="close">
      <div class="modal">
        <div class="modal-header">
          <h3>Детали разговора</h3>
          <button class="close-button-x" @click="close">&times;</button>
        </div>
        <div class="modal-content">
          <p>{{ conversationDetails}}</p>
        </div>
        <div class="modal-footer">
          <button @click="close" class="close-button ">Закрыть</button>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: "ConversationModal",
    props: {
      show: Boolean,
      conversationDetails: String,
    },
    methods: {
      close() {
        this.$emit("close");
      },
    },
  };
  </script>
  
  <style scoped>
  .modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
  }
  
  .modal {
    background: #fff;
    padding: 20px;
    border-radius: 8px;
    width: 400px;
    max-width: 90%;
  }
  
  .modal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #ddd;
  }
  
  .modal-content {
    padding: 10px 0;
  }
  
  .close-button {
    background: none;
    background-color: white;
    padding:12px;
    padding-left:24px;
    padding-right:24px;
    border: 1px solid black;
    border-radius: 10px;
    font-size: 16px;
    cursor: pointer;
  }

  .close-button-x{
    background: none;
    background-color: white;
    border: none;
    border-radius: 10px;
    font-size: 16px;
    cursor: pointer;
  }

  .modal-footer {
    display: flex;
    justify-content: center;
  }
  </style>
  